import React, { createContext, useState } from 'react'

export const BasketCounterContext = createContext()

const BasketCounterContextProvider = ({ children }) => {
    const [basketCount, setBasketCount] = useState(0)

    const addBasketItems = () => {
        setBasketCount(basketCount + 1)
    }

    const removeBasketItems = () => {
        setBasketCount(basketCount - 1)
    }

    const contextValues = {
        basketCount,
        addBasketItems,
        removeBasketItems,
    }

    return (
        <BasketCounterContext.Provider value={contextValues}>
            {children}
        </BasketCounterContext.Provider>
    )
}
export default BasketCounterContextProvider
